import { methodGet } from './methods';
import { API_INFO } from '../constants';

// Función para obtener la URL de SSO de ebooks
export const getEbooksSsoUrl = async () => {
  return methodGet(API_INFO + 'publishit/sso');
};